import SmartTipSatisfactionSurvey from './SmartTipSatisfactionSurvey';

export default SmartTipSatisfactionSurvey;
